import { render, staticRenderFns } from "./CarType.vue?vue&type=template&id=46479d42&scoped=true&"
import script from "./CarType.vue?vue&type=script&lang=js&"
export * from "./CarType.vue?vue&type=script&lang=js&"
import style0 from "./CarType.vue?vue&type=style&index=0&id=46479d42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46479d42",
  null
  
)

export default component.exports